import { StocksTableCell } from './StocksTableCell.component';
import { Product } from 'pleinchamp-api-client';
import { FC } from 'react';
import { IconButton } from '@components/buttons/IconButton/IconButton.component';
import { ChartIcon } from '@components/icons/Chart.icon';
import { PlcRow } from '@layout/components/PlcTable/PlcRow.component';
import { ElementComponents, StocksTableWidth } from '@stocks/business/StocksTable.utils';

export const StockDetailTableRow: FC<{
  elements: ElementComponents[];
  firstElement: ElementComponents;
  product: Product;
  onShowGraph?: (product: Product) => void;
}> = ({ elements, product, onShowGraph, firstElement }) => {
  function onClickGraph() {
    if (onShowGraph) {
      return onShowGraph(product);
    }
    return undefined;
  }

  return (
    <PlcRow key={product.id}>
      {firstElement.desktopBody}
      {elements.map((element) => element.desktopBody)}
      <StocksTableCell
        element={
          <IconButton className="full-width" onClick={onClickGraph}>
            <ChartIcon />
          </IconButton>
        }
        style={{ width: StocksTableWidth.chartCell }}
      />
    </PlcRow>
  );
};

export const StockDetailTableHeader: FC<{ elements: ElementComponents[]; firstElement: ElementComponents }> = ({
  elements,
  firstElement,
}) => {
  return (
    <PlcRow header={true} key="header">
      {firstElement.desktopHeader}
      {elements.map((element) => element.desktopHeader)}
      <StocksTableCell element="" header="headerInHeader" style={{ width: StocksTableWidth.chartCell }} />
    </PlcRow>
  );
};
